import Vue from 'vue'
import { Autorizacao } from '@/types/core'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'

const useRenovacaoAutorizacao = (() => {
  const state = Vue.observable({
    loadingConfirmar: false,
    loadingRenovar: '',
  })

  const autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()

  async function confirmarRenovacao(solicitacaoId: string): Promise<boolean> {
    state.loadingConfirmar = true
    state.loadingRenovar = solicitacaoId

    try {
      const response = await autorizacao.renovarAutorizacaoOperadora(solicitacaoId)

      if (!response.success) {
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao renovar a autorização.', 'error'))
        return false
      }

      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Autorização renovada com sucesso.', 'success'))
      return true
    } catch {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Ocorreu um erro ao renovar a autorização.', 'error'))
      return false
    } finally {
      state.loadingConfirmar = false
      state.loadingRenovar = ''
    }
  }

  return {
    get loadingConfirmar() { return state.loadingConfirmar },
    get loadingRenovar() { return state.loadingRenovar },
    confirmarRenovacao,
  }
})()

export default useRenovacaoAutorizacao
